export default function PageJsonLd() {
  const jsonLd = {
    "@context": "https://schema.org",
    "@graph": [
      {
        "@type": "WebPage",
        "name": "Мотивация и управление командой — обучение руководителей",
        "description": "Как мотивировать сотрудников и эффективно управлять командой? Практические инструменты для руководителей: цели, ответственность, обратная связь, развитие сотрудников, вовлечённость и командное взаимодействие.",
        "url": "https://business-training.by/menedzhment-i-liderstvo/motivatsiya-i-upravlenie-komandoy",
        "isPartOf": {
          "@type": "WebSite",
          "name": "Business Training",
          "url": "https://business-training.by"
        }
      },
      {
        "@type": "Service",
        "name": "Обучение мотивации и управлению командой",
        "description": "Корпоративное обучение руководителей навыкам мотивации сотрудников и управления командой: как выстроить управленческую систему, в которой сотрудники понимают цели, принимают ответственность, работают без постоянного давления и самостоятельно добиваются результата.",
        "provider": {
          "@type": "Person",
          "name": "Алексей Сивко",
          "jobTitle": "Бизнес-тренер, консультант по продажам и управлению, фасилитатор, сертифицированный коуч ICU",
          "url": "https://business-training.by/o-trenere",
          "sameAs": ["https://www.linkedin.com/in/alekseysivko", "https://t.me/a_sivko"]
        },
        "areaServed": [
          { "@type": "Country", "name": "Беларусь" },
          { "@type": "Country", "name": "Россия" },
          { "@type": "Country", "name": "Казахстан" },
          { "@type": "Country", "name": "Израиль" }
        ],
        "serviceType": "обучение руководителей, мотивация сотрудников, управление командой, развитие управленческих компетенций, вовлечённость сотрудников",
        "url": "https://business-training.by/menedzhment-i-liderstvo/motivatsiya-i-upravlenie-komandoy"
      },
      {
        "@type": "Person",
        "name": "Алексей Сивко",
        "jobTitle": "Бизнес-тренер",
        "description": "18+ лет практики в корпоративном обучении. 100+ корпоративных проектов, 450+ тренингов и бизнес-сессий, 4500+ участников. Средняя оценка участников — 9,09/10. Работал с компаниями Беларуси, России, Казахстана и Израиля.",
        "url": "https://business-training.by/o-trenere",
        "sameAs": ["https://www.linkedin.com/in/alekseysivko", "https://t.me/a_sivko"]
      },
      {
        "@type": "FAQPage",
        "mainEntity": [
          {
            "@type": "Question",
            "name": "Как мотивировать сотрудников?",
            "acceptedAnswer": {
              "@type": "Answer",
              "text": "Мотивация начинается не с отдельных приёмов, а с управленческой системы: понятные цели, зоны ответственности, критерии результата, своевременная обратная связь и признание достижений. Материальное вознаграждение важно, но не заменяет качество руководства, возможность развития и справедливые правила. Задача руководителя — выяснить, что влияет на вовлечённость конкретного сотрудника, и одновременно сохранять единые стандарты для всей команды."
            }
          },
          {
            "@type": "Question",
            "name": "Как повысить вовлечённость сотрудников?",
            "acceptedAnswer": {
              "@type": "Answer",
              "text": "Вовлечённость растёт, когда сотрудник понимает, зачем нужна его задача, видит связь своей работы с результатом компании, имеет полномочия принимать решения в своей зоне ответственности и получает обратную связь. Ключевые инструменты — постановка целей, делегирование ответственности, регулярная обратная связь, признание результата и возможности развития. Снижение вовлечённости чаще всего связано с управленческой системой, а не с самими сотрудниками."
            }
          },
          {
            "@type": "Question",
            "name": "Как руководителю мотивировать команду?",
            "acceptedAnswer": {
              "@type": "Answer",
              "text": "Руководитель мотивирует команду через создание условий, в которых сотрудникам понятно, что и зачем делать: чёткие цели, приоритеты, зоны ответственности, критерии результата, сроки и точки контроля. Дальше включаются регулярная обратная связь, признание достижений, развитие сотрудников и постепенное увеличение самостоятельности. Мотивация — это следствие управленческой системы, а не разовые приёмы или лозунги."
            }
          },
          {
            "@type": "Question",
            "name": "Что делать, если сотрудники работают только под контролем?",
            "acceptedAnswer": {
              "@type": "Answer",
              "text": "Если команда работает только при непосредственном присутствии руководителя, стоит пересмотреть управленческую модель: насколько понятны цели и критерии результата, есть ли у сотрудников полномочия принимать решения, как устроены контрольные точки и обратная связь. Переход от контроля каждого действия к контролю результата, а также постепенное увеличение самостоятельности помогают снять зависимость команды от постоянного надзора."
            }
          },
          {
            "@type": "Question",
            "name": "Как повысить самостоятельность сотрудников?",
            "acceptedAnswer": {
              "@type": "Answer",
              "text": "Самостоятельность развивается постепенно: руководитель задаёт рамки, определяет полномочия, обучает сотрудника принимать решения в своей зоне ответственности и не забирает задачу обратно после первой ошибки. Ошибки используются как материал для развития, а не как повод вернуть контроль. Важно устанавливать контрольные точки и соразмерять уровень свободы с компетентностью и ответственностью сотрудника."
            }
          },
          {
            "@type": "Question",
            "name": "Как правильно делегировать задачи?",
            "acceptedAnswer": {
              "@type": "Answer",
              "text": "Правильное делегирование — это передача не только задачи, но и ответственности за результат. Руководитель объясняет ожидаемый результат, срок, критерии качества, полномочия сотрудника и контрольные точки, а затем проверяет, как сотрудник понял задачу. Важно не забирать задачу обратно при первой ошибке и постепенно увеличивать уровень самостоятельности сотрудника."
            }
          },
          {
            "@type": "Question",
            "name": "Как сформировать сильную команду?",
            "acceptedAnswer": {
              "@type": "Answer",
              "text": "Сильная команда формируется вокруг общей цели, понятных ролей, правил взаимодействия, ответственности, доверия и регулярной обратной связи. Командообразование — это не только корпоративные мероприятия, а в первую очередь управленческая работа: постановка целей, распределение ролей, выстраивание коммуникации и управление результатом. Развлекательная активность может поддерживать команду, но не заменяет систему управления."
            }
          },
          {
            "@type": "Question",
            "name": "Чем мотивация сотрудников отличается от управления командой?",
            "acceptedAnswer": {
              "@type": "Answer",
              "text": "Мотивация отвечает на вопрос, почему сотрудники хотят выполнять работу, а управление командой — на вопрос, как организована работа для достижения результата. Мотивация является частью системы управления наряду с постановкой целей, распределением ответственности, контролем, обратной связью и развитием сотрудников. Поэтому развивать только мотивацию в отрыве от остальных управленческих компетенций неэффективно."
            }
          },
          {
            "@type": "Question",
            "name": "Подходит ли обучение новым руководителям?",
            "acceptedAnswer": {
              "@type": "Answer",
              "text": "Да, для новых руководителей обучение особенно полезно. Они часто сталкиваются с переходом от роли сильного специалиста к роли руководителя и испытывают трудности с делегированием, постановкой задач, обратной связью и мотивацией бывших коллег. Программа даёт базовые управленческие инструменты и практическую отработку, которая помогает быстрее освоить новую роль."
            }
          },
          {
            "@type": "Question",
            "name": "Можно ли адаптировать программу под конкретную компанию?",
            "acceptedAnswer": {
              "@type": "Answer",
              "text": "Да, адаптация — обязательный этап подготовки. Мы не используем шаблонные решения. Сначала разбираемся в реальных управленческих задачах компании: как руководители ставят цели, как распределена ответственность, как устроены контроль и обратная связь. После этого программа настраивается под уровень руководителей, отраслевую специфику и актуальные проблемы команды."
            }
          },
          {
            "@type": "Question",
            "name": "Сколько длится обучение руководителей?",
            "acceptedAnswer": {
              "@type": "Answer",
              "text": "Продолжительность зависит от задач компании и выбранного формата. Корпоративный тренинг обычно занимает 1–3 дня практической работы. Модульная программа может длиться несколько недель с практикой между модулями, а управленческая программа — несколько месяцев комплексного развития. Точный формат определяется после диагностики потребностей и обсуждения целей обучения."
            }
          },
          {
            "@type": "Question",
            "name": "Можно ли продолжить работу с руководителями после тренинга?",
            "acceptedAnswer": {
              "@type": "Answer",
              "text": "Да, сопровождение после обучения возможно и часто является частью программы. Мы разбираем реальные управленческие ситуации, которые возникли после тренинга: что получилось внедрить, где нужна корректировка, как дальше развивать навыки. Это помогает закрепить инструменты и перенести их в ежедневную управленческую практику."
            }
          }
        ]
      }
    ]
  };

  return (
    <script
      type="application/ld+json"
      dangerouslySetInnerHTML={{ __html: JSON.stringify(jsonLd) }}
    />
  );
}